module.exports = __webpack_public_path__ + "img/c4.58f94d11.png";